module.exports = __webpack_public_path__ + "static/media/anupam.3c707fd2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/members/anupam.jpg
 ** module id = 778
 ** module chunks = 0
 **/